var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('sidebar'),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"figbLogo"},[_c('img',{attrs:{"src":"http://www.federbridge.it/Mobile/Immagini/LogoFIGB.png","alt":"Logo"}})])
}]

export { render, staticRenderFns }